import { Default, Detail,  List, Create } from "./views";

const Module = {
    name: "saltedgeconnections",
    defaultRoutePath: "/legalentities/saltedgeconnection",
    menuItemScope: "legalentities",
    menuItemName: "saltedgeconnections",
    routes: [
        {
            path: "/legalentities/saltedgeconnection",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
